/**
 * Guard das rotas autenticadas do portal do paciente.
 *
 * Redireciona pra /portal/login quando o usuário não está logado como
 * paciente (sem Firebase user OU sem claim `role === 'PACIENTE'`).
 * Preserva o path original em `location.state.from` pra que o login
 * redirecione de volta ao destino original após sucesso.
 *
 * Separado do `ProtectedRoute` do staff porque o estado de auth do
 * portal vive em `PortalAuthContext`, não em `AuthContext`.
 */
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { usePortalAuth } from '@/hooks/usePortalAuth';

export const PortalProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isPortalAuthenticated, loading } = usePortalAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-surface-container-lowest flex items-center justify-center">
        <Spinner size={32} />
      </div>
    );
  }

  if (!isPortalAuthenticated) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
